import {
  LeaderboardUndeadBlocks,
  LeaderboardUndeadBlocksProps,
} from './LeaderboardUndeadBlocks';
import { CompetitionAccordion } from './CompetitionAcccordion';

export interface LeaderboardsAccordionProps {
  leaderboards: LeaderboardUndeadBlocksProps[];
  chosenLeaderboard: string;
}

export function LeaderboardsAccordion({
  leaderboards,
  chosenLeaderboard,
}: LeaderboardsAccordionProps) {
  const competitions = leaderboards
    .sort((a, b) => Number(b.date) - Number(a.date))
    .map((leaderboard) => ({
      title: leaderboard.title,
      date: leaderboard.date,
      endDate: leaderboard.endDate,
      prize: leaderboard.prize,
      Details: <LeaderboardUndeadBlocks {...leaderboard} />,
    }));
  return (
    <CompetitionAccordion
      competitions={competitions}
      chosen={Math.max(
        0,
        competitions.findIndex(
          (competition) => competition.title === chosenLeaderboard,
        ),
      )}
    />
  );
}
